<template>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center vertical">
      <div class="col-xl-9">
        <h1>Sign Up for Fivenomics</h1>

        <div class="box onboarding">
          <b-form @submit.prevent="submit" v-if="step === 1">
            <h2>User Info</h2>

            <user-info-form
              ref="user_form" :passwords="true"
              :data="data" :errors="errors" :loading="loading"
            />

            <div class="d-flex justify-content-end">
              <b-btn
                type="submit" variant="secondary" size="lg"
                :disabled="loading"
              >
                <span v-if="!loading">Next Step</span>
                <b-spinner v-if="loading" small></b-spinner>
              </b-btn>
            </div>
          </b-form>

          <b-form @submit.prevent="update" v-if="step === 2">
            <h2>Current Project Info</h2>

            <company-info-form
              ref="company_form"
              :data="data" :errors="errors" :loading="loading"
            />

            <div class="d-flex justify-content-end">
              <b-btn
                type="submit" variant="secondary" size="lg"
                :disabled="loading"
              >
                <span v-if="!loading">Next Step</span>
                <b-spinner v-if="loading" small></b-spinner>
              </b-btn>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserInfoForm from '@/components/users/UserInfoForm'
import CompanyInfoForm from '@/components/users/CompanyInfoForm'

export default {
  name: 'AuthRegister',
  components: {
    UserInfoForm,
    CompanyInfoForm
  },
  data () {
    return {
      data: {},
      user: {},
      errors: {},
      loading: false,
      step: 1
    }
  },
  methods: {
    submit () {
      this.loading = true
      this.errors = {}
      this.data = this.$refs.user_form.user
      this.user = this.$refs.user_form.user

      const formData = new FormData()
      for (let key in this.data) {
        if (!this.data[key]) {
          this.data[key] = ''
        }

        formData.append(key, this.data[key])
      }

      this.$http
        .post('/auth/register', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(
          () => {
            this.$auth.login({
              data: {
                email: this.data.email,
                password: this.data.password
              },
              rememberMe: true,
              fetchUser: true,
              redirect: false,
              success: () => {
                this.step = 2
              }
            })
          },
          (err) => {
            this.errors = err.response.data.errors
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
    update () {
      this.loading = true
      this.errors = {}
      this.data = this.$refs.company_form.company

      this.$http
        .post('/auth/company', this.data)
        .then(
          () => {
            this.$auth.fetch()
            if (this.user.user_type === 'advisor') {
              this.$router.push('register/calendar')
            } else {
              this.$router.push('register/schedule')
            }
          },
          (err) => {
            this.errors = err.response.data.errors
          }
        )
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
